import { SvgProps } from "../../types";

const Search1 = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={19}
    height={19}
    fill="none"
    {...props}>
    <path
      fill={props?.fill ? props?.fill || "#5F6368" : "#5F6368"}
      d="M7.7 13.016c1.5 0 2.775-.525 3.825-1.575 1.05-1.05 1.575-2.325 1.575-3.825s-.525-2.775-1.575-3.825C10.475 2.741 9.2 2.216 7.7 2.216s-2.775.525-3.825 1.575C2.825 4.841 2.3 6.116 2.3 7.616s.525 2.775 1.575 3.825c1.05 1.05 2.325 1.575 3.825 1.575Zm-.9-2.7v-6.3h1.8v6.3H6.8Zm-3.15 0v-4.5h1.8v4.5h-1.8Zm6.3 0v-3.6h1.8v3.6h-1.8Zm7.29 8.1-5.107-5.107A7.133 7.133 0 0 1 7.7 14.816c-2.01 0-3.713-.697-5.107-2.092C1.198 11.329.5 9.626.5 7.616s.698-3.712 2.092-5.107C3.987 1.114 5.69.416 7.7.416s3.712.698 5.107 2.093C14.203 3.904 14.9 5.606 14.9 7.616a7.134 7.134 0 0 1-1.508 4.433l5.108 5.107-1.26 1.26Z"
    />
  </svg>
);
export default Search1;
